import React, { Component } from "react";
import api from '../../../config/api';
import configData from '../../../config/config.js';

class GenderList extends Component {
    constructor(props) {
        super(props);
        this.getGenderlist = this.getGenderlist.bind(this);
        
        this.state = {
 
            'genderlist': {},
            
        };

        
    }

    componentDidMount() {
        this.getGenderlist();

    }

    getGenderlist() {
        //LISTS
        api.get(configData.API + '/genderlist').then((request) => {
            
            this.setState({
                genderlist: request.data.data
            });

        }).catch((err) => {
            console.log(err);
        });
    }


    render() {
        const options = Object.keys(this.state.genderlist).map((key) =>
            <option key={this.state.genderlist[key].id} value={this.state.genderlist[key].id} > {this.state.genderlist[key].description}</option>
        );

        return (
                <>
                    <label>Sexo * </label>
                    <select
                        id='gender_id'
                        name='gender_id'
                        className={(this.props.errors.gender_id) ? 'form-control m-b-5 is-invalid' : 'form-control m-b-5'}
                        disabled={this.props.disabled}
                        value={this.props.gender}
                        onChange={this.props.handleChangeGender}
                        onBlur={this.props.handleBlur}
                       
                    >   
                        <option value="">Selecione um Género</option>
                        {options}
                    </select>
                </>
            )
    }


}

export default GenderList;